import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import LocationUserList from './components/LocationUserList';

const LocationUsers = () => {
  return renderComponent(<LocationUserList />);
};

export default LocationUsers;
